var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group search-input"},[_c('fa',{staticClass:"search-input__icon",attrs:{"icon":"search","fixed-width":""}}),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"search","placeholder":"Search"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }